import { HELP_DRAWER } from './constants';
import type { TPTTranslations } from './types';

export const pt: TPTTranslations = {
  [HELP_DRAWER]: {
    HELP_TITLE: 'Ayuda',

    HELP_DRAWER_TITLE: 'Ajuda',
    HELP_DRAWER_RECOMMENDED: 'artigos recomendados',
    HELP_DRAWER_ARTICLE_1: 'Como faço para enviar usuários para Crehana?',
    HELP_DRAWER_ARTICLE_2: 'Como gerenciar usuários?',
    HELP_DRAWER_ARTICLE_3: 'Criar atributos',
    HELP_DRAWER_ARTICLE_4: 'Como vejo o desempenho dos meus atributos?',
    HELP_DRAWER_HELP_CENTER: 'Veja mais na Central de Ajuda',
    HELP_DRAWER_TECH_ASSISTANCE: 'assistência técnica',
    HELP_DRAWER_DOUBTS_TITLE: 'Dúvidas e consultas',
    HELP_DRAWER_DOUBTS_SUBTITLE: 'Obtenha suporte de nossa equipe',
    HELP_DRAWER_FEEDBACK_TITLE: 'Deixe-nos o seu feedback',
    HELP_DRAWER_FEEDBACK_SUBTITLE: 'Seu feedback é importante',
    HELP_DRAWER_EMAIL_TITLE: 'Ainda em dúvida? Escreva-nos em:',
  },
};
